import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const VivaEngageIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={classes.svg}
      focusable="false"
    >
      <path
        d="M8 0C12.4183 0 16 3.58172 16 8L16 18H0V8C0 3.58172 3.58172 0 8 0Z"
        fill="url(#paint0_linear_134_148781)"
      />
      <path
        d="M24 0C19.5817 0 16 3.58172 16 8L16 18H32V8C32 3.58172 28.4183 0 24 0Z"
        fill="url(#paint1_linear_134_148781)"
      />
      <path
        d="M24 13C24 8.58172 20.4183 5 16 5C11.5817 5 8 8.58172 8 13C8 17.4183 11.5817 21 16 21C20.4183 21 24 17.4183 24 13Z"
        fill="url(#paint2_linear_134_148781)"
      />
      <path
        d="M31.9983 7.83203H31.9937C31.8009 12.9115 26.9689 17 22 17C17.5817 17 14 20.3579 14 24.5C14 28.6421 17.5817 32 22 32C22.0764 32 22.1526 31.999 22.2286 31.997V32C30.4571 32 32 24.1458 32 20.5V8C32 7.94387 31.9994 7.88788 31.9983 7.83203Z"
        fill="url(#paint3_linear_134_148781)"
      />
      <path
        d="M0 8V20.5C0 24.1458 1.54286 32 9.77143 32V31.997C9.84736 31.999 9.92355 32 10 32C14.4183 32 18 28.6421 18 24.5C18 20.3579 14.4183 17 10 17C5.03105 17 0.199129 12.9115 0.00629317 7.83203H0.00172835C0.000577993 7.88788 0 7.94387 0 8Z"
        fill="url(#paint4_linear_134_148781)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_134_148781"
          x1="3"
          y1="15.6667"
          x2="6.52301"
          y2="-1.02832"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#053377" />
          <stop offset="1" stop-color="#2F91F2" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_134_148781"
          x1="26.6805"
          y1="2.47731"
          x2="18.6667"
          y2="14.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4AC1FF" />
          <stop offset="0.926632" stop-color="#155EB5" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_134_148781"
          x1="13.8333"
          y1="7.16667"
          x2="21.6667"
          y2="22.6667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#96DFFF" />
          <stop offset="0.413439" stop-color="#53ADEE" />
          <stop offset="1" stop-color="#006BB9" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_134_148781"
          x1="19.7736"
          y1="19.4194"
          x2="28.113"
          y2="33.6775"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0799194" stop-color="#4AC1FF" />
          <stop offset="1" stop-color="#155EB5" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_134_148781"
          x1="3.41586"
          y1="13.8763"
          x2="11.1995"
          y2="33.1337"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2F91F2" />
          <stop offset="1" stop-color="#053377" />
        </linearGradient>
      </defs>
    </svg>
  ),
  displayName: 'VivaEngageIcon',
});

export default VivaEngageIcon;
